export const SET_HELP_TOPICS = "SET_HELP_TOPICS";
export const SET_IS_VIEWING_HELP = "SET_IS_VIEWING_HELP";
export const SET_TEMP_HELP_TOPIC_KEY = "SET_TEMP_HELP_TOPIC_KEY";
export const SET_COMPONENT_HELP_TOPIC_KEY = "SET_COMPONENT_HELP_TOPIC_KEY";
export const SET_ROUTE_HELP_TOPIC_KEY = "SET_ROUTE_HELP_TOPIC_KEY";
export const SET_DEFAULT_HELP_TOPIC_KEY = "SET_DEFAULT_HELP_TOPIC_KEY";
